export default function SendIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.1624 5.25083C18.4469 5.50235 18.5644 5.89331 18.4656 6.25999L14.9656 19.26C14.8498 19.6902 14.4633 19.992 14.0178 19.9999C13.5723 20.0078 13.1753 19.72 13.0442 19.2941L11.2102 13.3333L5.25748 11.8452C4.83764 11.7402 4.53296 11.3771 4.5025 10.9454C4.47203 10.5137 4.7227 10.1114 5.12364 9.94855L17.1236 5.07355C17.4755 4.93063 17.8779 4.9993 18.1624 5.25083ZM8.71548 10.6481L12.2426 11.5299L12.7899 11.6667L12.9558 12.2059L13.9359 15.3914L16.0109 7.68432L8.71548 10.6481Z"
        fill="white"
      />
    </svg>
  );
}
